<template>
  <div>
    <section class="content">
      <ul v-if="details != ''">
        <li>
          <h3>{{ details.user_name }}</h3>
        </li>
        <br />
        <li>
          <label>手机号：</label>
          <p>{{ details.phone }}</p>
        </li>
        <br />
        <li>
          <label>申请时间：</label>
          <p>{{ details.create_time }}</p>
        </li>
        <br />
        <li>
          <label>项目：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <br />
        <li>
          <label>预支结算月：</label>
          <p>{{ details.month }}</p>
        </li>
        <br />
        <li>
          <label>预支金额：</label>
          <p>{{ Number(details.amount) + "元" }}</p>
        </li>
        <li>
          <label>手续费：</label>
          <p>{{ Number(details.service_amount) + "元" }}</p>
        </li>
        <li>
          <label>打款金额：</label>
          <p>{{ Number(details.pre_out_amount) + "元" }}</p>
        </li>
        <li>
          <label>工单金额：</label>
          <p>{{ Number(details.can_amount) + "元" }}</p>
        </li>
        <li>
          <label>预支比例：</label>
          <p>{{ details.proportion + "%" }}</p>
        </li>
        <li>
          <label>已预支金额：</label>
          <p>{{ Number(details.amount_out) + "元" }}</p>
        </li>
        <li>
          <label>状态：</label>
          <p v-show="details.status == 10">待项目经理审核</p>
          <p v-show="details.status == 20">待项目总监审核</p>
          <p v-show="details.status == 21">项目经理驳回</p>
          <p v-show="details.status == 31">项目总监驳回</p>
          <p v-show="details.status == 30 && details.xf_status == 40">待打款</p>
          <p v-show="details.status == 30 && details.xf_status == 41">
            出纳驳回
          </p>
          <p v-show="details.status == 30 && details.xf_status == 50">
            结算完成
          </p>
        </li>
        <li>
          <label>项目经理：</label>
          <div class="auditor">
            <span v-for="(element, i) in details.area_user_list" :key="i">
              <a>{{ element.user_name + "&nbsp;" + element.phone }}</a>
            </span>
          </div>
        </li>
        <li>
          <label>项目总监：</label>
          <div class="auditor">
            <span v-for="(element, i) in details.project_user_list" :key="i">
              <a>{{ element.user_name + "&nbsp;" + element.phone }}</a>
            </span>
          </div>
        </li>
        <br />
        <li v-show="details.status == 21 || details.status == 31">
          <label>驳回原因：</label>
          <p v-show="details.status == 21">{{ details.area_reason }}</p>
          <p v-show="details.status == 31">{{ details.project_reason }}</p>
        </li>
        <br />
        <li>
          <label>员工身份证号：</label>
          <p>{{ details.idcard }}</p>
        </li>
        <li>
          <label>员工银行名称：</label>
          <p>{{ details.bank_name }}</p>
        </li>
        <li>
          <label>员工银行卡号：</label>
          <p>{{ details.bank_card_number }}</p>
        </li>
        <li v-show="details.status == 30 && details.xf_status == 50">
          <label>实际到账金额：</label>
          <p>{{ Number(details.real_out_amount) + "元" }}</p>
        </li>
        <li v-show="details.status != 10">
          <label>片区审核人：</label>
          <p>{{ details.area_user_name }}</p>
        </li>
        <li v-show="details.status != 10">
          <label>片区审核时间：</label>
          <p>{{ details.area_time }}</p>
        </li>
        <li
          v-show="
            details.status != 10 && details.status != 20 && details.status != 21
          "
        >
          <label>项目审核人：</label>
          <p>{{ details.project_user_name }}</p>
        </li>
        <li
          v-show="
            details.status != 10 && details.status != 20 && details.status != 21
          "
        >
          <label>项目审核时间：</label>
          <p>{{ details.project_time }}</p>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      details: {}
    };
  },
  props: {
    detailsVal: {}
  },
  watch: {
    detailsVal() {
      this.getDetails();
    }
  },
  mounted() {
    if (this.detailsVal != undefined) {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.details = this.detailsVal;
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  margin: 30px 4%;
  > ul {
    > li {
      display: inline-block;
      width: 33.3%;
      margin-bottom: 10px;
      h3 {
        font-size: 16px;
        line-height: 24px;
        font-weight: normal;
      }
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
  .auditor {
    display: inline-block;
    vertical-align: top;
    > span {
      display: block;
      a {
        color: #666;
        font-size: 14px;
        line-height: 18px;
      }
    }
  }
}
</style>
